<div class="cd-section" id="regulations" style="background-color: white; padding-top: 100px">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h1>White Papers <span class="badge badge-pill badge-info align-top" style="font-size: .5em;">{{ papers.length }}</span></h1>
                    <h5>The compliance team at RegScale continues to share our thought leadership to advance the state of practice for compliance in the industry. The current list of published white papers is shown below: </h5>
                    <div class="input-group mt-4">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="strSearch" aria-label="search" name="search" aria-describedby="basic-addon1" (keyup.enter)="filter()">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table m-4">
                    <thead>
                        <tr>
                            <th style="font-weight: bold;">View</th>
                            <th style="font-weight: bold;">Paper Title</th>
                            <th style="font-weight: bold;">Date Published</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of filtered">
                            <td>
                                <a [href]="r.url" [title]="r.title" target="_blank" class="btn btn-primary">Read the Paper</a>
                            </td>
                            <td>
                                {{ r.title }}
                            </td>
                            <td>
                                {{ r.datePublished }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

